import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
// import '@/stylus/main.styl';
import { Scroll } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#003E86',
    secondary: '#424242',
    accent: '#EA6E2E',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  directives: {
    Scroll
  }
});
